module.exports = __webpack_public_path__ + "img/Trustweaver.10df16e3.png";